module.exports = __webpack_public_path__ + "static/img/df-desk.d585f644.png";